import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../../../core/config/environment";
import { Community } from "../lot-community-search/lot-community-search.component";

@Injectable({
  providedIn: "root"
})
export class LotSearchService {
  private readonly getSalesCommunitiesUrl =
    `${environment.backend.apiBaseURL}/api/lot/GetSalesCommunities`;

  constructor(private http: HttpClient) { }

  getSalesCommunitiesByDivision(externalDivisionId: number): Observable<Community[]> {
    return this.http.get<Community[]>(
      `${this.getSalesCommunitiesUrl}?divisionId=${externalDivisionId}`
    );
  }
}